import React from 'react';
import PropTypes from 'prop-types';

const Wrapper = props => (
  <div className={props.className}>
    {props.elements}
  </div>
);

Wrapper.PropTypes = {
  className:PropTypes.string,
  elements:PropTypes.array.isRequired,
};

export default Wrapper;
